<template>
  <div class="header-box">
    <div class="header">
      <span class="colorspan">{{ titleName }}</span>
    </div>
    <div class="table-content">
      <table border="1">
        <tr>
          <th colspan="6">一、基本信息</th>
        </tr>
        <tr>
          <th>申报单位名称</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.unitName" />
          </td>
          <th>法定代表人</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.representative" />
          </td>
        </tr>
        <tr>
          <th>拟申报基地名称</th>
          <td colspan="5"><input type="text" v-model="dataInfo.baseName" /></td>
        </tr>
        <tr>
          <th>申报入口</th>
          <td colspan="5">
            <input type="text" readonly v-model="dataInfo.entrance" />
          </td>
        </tr>
        <tr>
          <th>申报单位类型</th>
          <td style="width: 554px" colspan="5">
            <select v-model="dataInfo.unitType" placeholder="请选择" @change="handleChange">
              <option v-for="(item, i) in unitList" :key="i" :value="item.value">
                {{ item.name }}
              </option>
            </select>
          </td>
        </tr>
        <tr>
          <th>申报基地类型</th>
          <td style="width: 554px" colspan="5">
            <select v-model="dataInfo.baseType" placeholder="请选择" @change="handleChange">
              <option v-for="(item, i) in baseList" :key="i" :value="item.value">
                {{ item.name }}
              </option>
            </select>
          </td>
        </tr>
        <tr>
          <th>市级社科普及基地</th>
          <td style="width: 554px" colspan="5">
            <select v-model="dataInfo.popularBase" placeholder="请选择" @change="handleChange">
              <option v-for="(item, i) in cityBaseList" :key="i" :value="item.value">
                {{ item.name }}
              </option>
            </select>
          </td>
        </tr>
        <tr>
          <th>上级主管单位</th>
          <td colspan="5">
            <input type="text" v-model="dataInfo.supervisorUnit" />
          </td>
        </tr>
        <tr>
          <th>基地负责人</th>
          <td><input type="text" v-model="dataInfo.responsor" /></td>
          <th>职务职称</th>
          <td><input type="text" v-model="dataInfo.responsorPosition" /></td>
          <th>手机</th>
          <td><input type="text" v-model="dataInfo.responsorPhone" /></td>
        </tr>
        <tr>
          <th>基地联络员</th>
          <td><input type="text" v-model="dataInfo.contact" /></td>
          <th>职务职称</th>
          <td><input type="text" v-model="dataInfo.contactPosition" /></td>
          <th>手机</th>
          <td><input type="text" v-model="dataInfo.contactPhone" /></td>
        </tr>
        <tr>
          <th>通讯地址</th>
          <td colspan="5">
            <input type="text" v-model="dataInfo.mailingAddress" />
          </td>
        </tr>
        <tr>
          <th>邮政编码</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.postcode" />
          </td>
          <th>电话（传真）</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.phone" />
          </td>
        </tr>
        <tr>
          <th>官方网络平台</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.platform" placeholder="（网址、微博或微信公众号）" />
          </td>
          <th>电子邮箱</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.email" />
          </td>
        </tr>
        <tr>
          <th>财务账号名称</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.financialAccount" />
          </td>
          <th>开户行及账号</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.bankAccount" />
          </td>
        </tr>
        <tr>
          <th>社科普及场所面积</th>
          <td colspan="5">
            <select v-model="dataInfo.siteArea" placeholder="请选择" @change="handleChange">
              <option v-for="(item, i) in siteAreaList" :key="i" :value="item.value">
                {{ item.name }}
              </option>
            </select>
          </td>
        </tr>
        <tr>
          <th>科普经费及来源</th>
          <td colspan="5">
            <input type="text" v-model="dataInfo.fundsSource" />
          </td>
        </tr>
        <tr>
          <th colspan="6" style="position: relative">
            二、社科普及资源状况（上传证明材料）
            <div class="newOperate">
              <a-spin :spinning="spinning" tip="上传中">
                <div class="upload">
                  <span v-if="dataInfo.fileName1 == ''">
                    仅支持PDF格式，限制1个！
                  </span>
                  <a-upload v-if="dataInfo.fileName1 == ''" :customRequest="uploaderCoverUrlOne" :show-upload-list="false"
                    accept=".pdf">
                    <a-button style="margin-top: 5px" v-if="saveStatus == 0 || declareStatus == 0">
                      <a-icon type="upload" />本地上传
                    </a-button>
                    <a-button style="margin-top: 5px" v-if="userTypeValue == 'declarator' &&
                      routerKey.indexOf('declarationCenter') > -1 &&
                      (declareStatus == 2 || declareStatus == 3) &&
                      newToTarget == 'declarator'
                      ">
                      <a-icon type="upload" />本地上传
                    </a-button>
                  </a-upload>
                  <div class="file" v-else>
                    <span :title="dataInfo.fileName1" @click="preview(1)" class="file-title">
                      查看附件：{{ dataInfo.fileName1 }}
                    </span>
                    <a-icon type="close" v-if="saveStatus == 0 || declareStatus == 0" @click="removeFile(1)" />
                    <a-icon type="close" v-if="userTypeValue == 'declarator' &&
                      routerKey.indexOf('declarationCenter') > -1 &&
                      (declareStatus == 2 || declareStatus == 3) &&
                      newToTarget == 'declarator'
                      " @click="removeFile(1)" />
                  </div>
                </div>
              </a-spin>
            </div>
          </th>
        </tr>
        <tr>
          <th>场馆设施或普及平台情况（不超过800字）</th>
          <td colspan="5">
            <textarea cols="50" rows="11" maxlength="800" v-model="dataInfo.content1"
              placeholder="（主要填写申报单位的场馆或其他普及平台的场所面积、配套设施和社科普及资源情况）" id="contactus" name="contactus"></textarea>
          </td>
        </tr>
        <tr>
          <th>特色普及资源或品牌项目（不超过800字）</th>
          <td colspan="5">
            <textarea maxlength="800" cols="50" rows="11" v-model="dataInfo.content2"
              placeholder="（主要填写申报单位的学科专业、特色资源和重要的社科普及活动等方面内容）" id="contactus" name="contactus"></textarea>
          </td>
        </tr>
        <tr>
          <th colspan="6" style="position: relative">
            三、社科普及工作人员及专家骨干（可附相关证明材料）
            <div class="newOperate">
              <a-spin :spinning="spinning2" tip="上传中">
                <div class="upload">
                  <span v-if="dataInfo.fileName2 == ''">
                    仅支持PDF格式，限制1个！
                  </span>
                  <a-upload v-if="dataInfo.fileName2 == ''" :customRequest="uploaderCoverUrlOne2"
                    :show-upload-list="false" accept=".pdf">
                    <a-button style="margin-top: 5px" v-if="saveStatus == 0 || declareStatus == 0">
                      <a-icon type="upload" />本地上传
                    </a-button>
                    <a-button style="margin-top: 5px" v-if="userTypeValue == 'declarator' &&
                      routerKey.indexOf('declarationCenter') > -1 &&
                      (declareStatus == 2 || declareStatus == 3) &&
                      newToTarget == 'declarator'
                      ">
                      <a-icon type="upload" />本地上传
                    </a-button>
                  </a-upload>
                  <div class="file" v-else>
                    <span :title="dataInfo.fileName2" @click="preview(2)" class="file-title">
                      查看附件：{{ dataInfo.fileName2 }}
                    </span>
                    <a-icon type="close" v-if="saveStatus == 0 || declareStatus == 0" @click="removeFile(2)" />
                    <a-icon type="close" v-if="userTypeValue == 'declarator' &&
                      routerKey.indexOf('declarationCenter') > -1 &&
                      (declareStatus == 2 || declareStatus == 3) &&
                      newToTarget == 'declarator'
                      " @click="removeFile(2)" />
                  </div>
                </div>
              </a-spin>
            </div>
            <!-- <svg
              t="1677121306615"
              class="icon svg"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2767"
              width="30"
              height="30"
              @click="addExpert"
            >
              <path
                d="M512 127.9992c-212.0776 0-384 171.9232-384 384.0008s171.9224 384 384 384 384-171.9232 384-384S724.0776 127.9992 512 127.9992zM672 536 536 536l0 136-48 0L488 536 352 536l0-48 136 0L488 352l48 0 0 136 136 0L672 536z"
                p-id="2768"
                fill="#42485b"
              ></path>
            </svg> -->
          </th>
        </tr>
        <tr>
          <td colspan="6">
            <textarea cols="50" rows="11" v-model="dataInfo.content3"
              placeholder="（主要包括社科普及工作人员、专家骨干的主要来源、姓名、职务或职称、专业方向和参加普及活动或普及类成果等情况）" id="contactus"
              name="contactus"></textarea>
          </td>
        </tr>
        <!-- <tbody v-for="(item, index) in dataInfo.expertDtoList" :key="index">
          <tr colspan="6">
            <th>姓名</th>
            <td><input type="text" v-model="item.expertName" /></td>
            <th>职务或职称</th>
            <td><input type="text" v-model="item.expertJob" /></td>
            <th>专业方向</th>
            <td><input type="text" v-model="item.expertMajor" /></td>
          </tr>
          <tr>
            <th>参加普及活动或普及类成果</th>
            <td colspan="3">
              <textarea
                style="height: 156px; margin-bottom: -71px"
                cols="50"
                rows="11"
                v-model="item.expertAchievement"
                id="contactus"
                name="contactus"
              ></textarea>
            </td>
            <th>联系方式</th>
            <td>
              <input
                style="height: 156px"
                type="text"
                v-model="item.expertPhone"
              />
            </td>
          </tr>
        </tbody> -->
        <tr>
          <th colspan="6" style="position: relative">
            四、志愿者队伍情况（上传证明材料）
            <div class="newOperate">
              <a-spin :spinning="spinning3" tip="上传中">
                <div class="upload">
                  <span v-if="dataInfo.fileName3 == ''">
                    仅支持PDF格式，限制1个！
                  </span>
                  <a-upload v-if="dataInfo.fileName3 == ''" :customRequest="uploaderCoverUrlOne3"
                    :show-upload-list="false" accept=".pdf">
                    <a-button style="margin-top: 5px" v-if="saveStatus == 0 || declareStatus == 0">
                      <a-icon type="upload" />本地上传
                    </a-button>
                    <a-button style="margin-top: 5px" v-if="userTypeValue == 'declarator' &&
                      routerKey.indexOf('declarationCenter') > -1 &&
                      (declareStatus == 2 || declareStatus == 3) &&
                      newToTarget == 'declarator'
                      ">
                      <a-icon type="upload" />本地上传
                    </a-button>
                  </a-upload>
                  <div class="file" v-else>
                    <span :title="dataInfo.fileName3" @click="preview(3)" class="file-title">
                      查看附件：{{ dataInfo.fileName3 }}
                    </span>
                    <a-icon type="close" v-if="saveStatus == 0 || declareStatus == 0" @click="removeFile(3)" />
                    <a-icon type="close" v-if="userTypeValue == 'declarator' &&
                      routerKey.indexOf('declarationCenter') > -1 &&
                      (declareStatus == 2 || declareStatus == 3) &&
                      newToTarget == 'declarator'
                      " @click="removeFile(3)" />
                  </div>
                </div>
              </a-spin>
            </div>
          </th>
        </tr>
        <tr>
          <td colspan="6">
            <textarea cols="50" rows="11" v-model="dataInfo.content4"
              placeholder="（主要填写申报单位的社科普及志愿者队伍建设情况，主要包括志愿者主要来源、具体组成、承担的工作以及开展志愿服务活动等情况。可添加页面）" id="contactus"
              name="contactus"></textarea>
          </td>
        </tr>
        <tr>
          <th colspan="6" style="position: relative">
            五、近两年社科普及相关工作和社会成效（上传证明材料）
            <div class="newOperate">
              <a-spin :spinning="spinning4" tip="上传中">
                <div class="upload">
                  <span v-if="dataInfo.fileName4 == ''">
                    仅支持PDF格式，限制1个！
                  </span>
                  <a-upload v-if="dataInfo.fileName4 == ''" :customRequest="uploaderCoverUrlOne4"
                    :show-upload-list="false" accept=".pdf">
                    <a-button style="margin-top: 5px" v-if="saveStatus == 0 || declareStatus == 0">
                      <a-icon type="upload" />本地上传
                    </a-button>
                    <a-button style="margin-top: 5px" v-if="userTypeValue == 'declarator' &&
                      routerKey.indexOf('declarationCenter') > -1 &&
                      (declareStatus == 2 || declareStatus == 3) &&
                      newToTarget == 'declarator'
                      ">
                      <!-- v-if="userTypeValue == 'declarator' && declareStatus == 2" -->
                      <a-icon type="upload" />本地上传
                    </a-button>
                  </a-upload>
                  <div class="file" v-else>
                    <span :title="dataInfo.fileName4" @click="preview(4)" class="file-title">
                      查看附件：{{ dataInfo.fileName4 }}
                    </span>
                    <a-icon type="close" v-if="saveStatus == 0 || declareStatus == 0" @click="removeFile(4)" />
                    <a-icon type="close" v-if="userTypeValue == 'declarator' &&
                      routerKey.indexOf('declarationCenter') > -1 &&
                      (declareStatus == 2 || declareStatus == 3) &&
                      newToTarget == 'declarator'
                      " @click="removeFile(4)" />
                  </div>
                </div>
              </a-spin>
            </div>
          </th>
        </tr>
        <tr>
          <td colspan="6">
            <textarea cols="50" rows="11" v-model="dataInfo.content5"
              placeholder="（主要填写申报单位相关社科普及载体与资源，近两年社科普及活动的主要内容、规模、特色、成效和社会影响。可添加页面）" id="contactus"
              name="contactus"></textarea>
          </td>
        </tr>
        <tr>
          <th colspan="6" style="position: relative">
            六、社科普及基地建设的基本思路与规划方案
            <div class="newOperate">
              <a-spin :spinning="spinning5" tip="上传中">
                <div class="upload">
                  <span v-if="dataInfo.fileName5 == ''">
                    仅支持PDF格式，限制1个！
                  </span>
                  <a-upload v-if="dataInfo.fileName5 == ''" :customRequest="uploaderCoverUrlOne5"
                    :show-upload-list="false" accept=".pdf">
                    <a-button style="margin-top: 5px" v-if="saveStatus == 0 || declareStatus == 0">
                      <a-icon type="upload" />本地上传
                    </a-button>
                    <a-button style="margin-top: 5px" v-if="userTypeValue == 'declarator' &&
                      routerKey.indexOf('declarationCenter') > -1 &&
                      (declareStatus == 2 || declareStatus == 3) &&
                      newToTarget == 'declarator'
                      ">
                      <a-icon type="upload" />本地上传
                    </a-button>
                  </a-upload>
                  <div class="file" v-else>
                    <span :title="dataInfo.fileName5" @click="preview(5)" class="file-title">
                      查看附件：{{ dataInfo.fileName5 }}
                    </span>
                    <a-icon type="close" v-if="saveStatus == 0 || declareStatus == 0" @click="removeFile(5)" />
                    <a-icon type="close" v-if="userTypeValue == 'declarator' &&
                      routerKey.indexOf('declarationCenter') > -1 &&
                      (declareStatus == 2 || declareStatus == 3) &&
                      newToTarget == 'declarator'
                      " @click="removeFile(5)" />
                  </div>
                </div>
              </a-spin>
            </div>
          </th>
        </tr>
        <tr>
          <td colspan="6">
            <textarea cols="50" rows="11" v-model="dataInfo.content6" placeholder="（主要填写申报单位关于基地建设和开展社科普及工作的规划和设想。可添加页面）"
              id="contactus" name="contactus"></textarea>
          </td>
        </tr>
      </table>
    </div>
    <div class="radio" v-if="chooseType == 1 || chooseType == 2">
      <p>市级意见：</p>
      <a-radio-group v-model="dataInfo.cityOpinion" name="radioGroup">
        <a-radio value="推荐">推荐</a-radio>
        <a-radio value="不推荐">不推荐</a-radio>
      </a-radio-group>
    </div>
    <div class="radio" style="margin-top: 10px" v-if="userTypeValue == 'expert'">
      <p>专家评审：</p>
      <a-radio-group v-model="dataInfo.expertOpinion" name="radioGroup">
        <a-radio value="推荐">推荐</a-radio>
        <a-radio value="不推荐">不推荐</a-radio>
      </a-radio-group>
    </div>
    <!-- <div class="radio">
      <p>终评意见：</p>
      <a-radio-group v-model="dataInfo.municipalOpinion" name="radioGroup">
        <a-radio value="0">认定</a-radio>
        <a-radio value="1">不认定</a-radio>
      </a-radio-group>
    </div> -->
    <div class="footer">
      <!-- 0410修改 -->
      <!-- <a-button
        type="primary"
        @click="save(0)"
        v-if="
          saveStatus == 0 ||
          declareStatus == 0 ||
          (saveStatus == 1 && declareStatus == 2) ||
          (saveStatus == 1 && declareStatus == 3)
        "
        >保存草稿</a-button
      > -->
      <a-button type="primary" @click="save(0)" v-if="saveStatus == 0 ||
        declareStatus == 0 ||
        (saveStatus == 1 && declareStatus == 2)
        ">保存草稿</a-button>
      <!-- 0410修改 -->
      <!-- <a-button
        type="primary"
        @click="save(1)"
        v-if="
          saveStatus == 0 ||
          declareStatus == 0 ||
          (saveStatus == 1 && declareStatus == 2) ||
          (saveStatus == 1 && declareStatus == 3)
        "
        >提交</a-button
      > -->
      <a-button type="primary" @click="save(1)" v-if="saveStatus == 0 ||
        declareStatus == 0 ||
        (saveStatus == 1 && declareStatus == 2) ||
        (saveStatus == 1 && declareStatus == 3 && titleName !== '社科普及基地申报信息')
        ">提交</a-button>

      <!-- 市级保存按钮 -->
      <a-button type="primary" @click="save(1)" v-if="toTarget == 'cityAdm'">保存</a-button>
      <a-button type="primary" @click="save(1)" v-if="(declareStatus == 0 || declareStatus == 3 || declareStatus == 5) &&
        saveStatus != 0 &&
        toTarget == 'declarator'
        ">
        保存
      </a-button>
      <!-- 省属申报保存按钮 -->
      <a-button type="primary" @click="save(1)"
        v-if="declareStatus == 3 && saveStatus == 1 && userTypeValue == 'declarator' && $route.meta.title == '基地申报'">保存</a-button>
      <a-button type="primary" @click="saveExpertOpinion" v-if="userTypeValue == 'expert'">保存</a-button>

      <a-button @click="cancel">返回</a-button>
    </div>
  </div>
</template>

<script>
import { UploadOutlined, CloseOutlined } from "@ant-design/icons-vue";
import {
  createdecInformationApi,
  decInformationMyListApi,
  updateDecInformationApi,
  openUploadApi,
  decUserAccessUpdateApi,
} from "@/api/declare";
export default {
  props: {
    chooseType: {
      type: Number,
      default: 0,
    },
    toTarget: {
      type: String,
    },
  },
  data() {
    return {
      userTypeValue: "",
      saveStatus: 0,
      declareStatus: 0,
      routerKey: "",
      titleName: "社科普及基地申报信息",
      spinning: false,
      spinning2: false,
      spinning3: false,
      spinning4: false,
      spinning5: false,
      dataInfo: {
        unitName: "" /* 申报单位名称 */,
        representative: "" /* 法定代表人 */,
        baseName: "" /* 申报基地名称 */,
        entrance: "",
        supervisorUnit: "",
        responsor: "" /* 基地负责人 */,
        responsorPosition: "" /* 基地负责人职务 */,
        responsorPhone: "" /* 基地负责人手机 */,
        contact: "" /* 基地联系人 */,
        contactPosition: "" /* 基地联系人职务 */,
        contactPhone: "" /* 基地联系人手机 */,
        mailingAddress: "" /* 通讯地址 */,
        postcode: "",
        phone: "",
        email: "",
        financialAccount: "",
        bankAccount: "",
        siteArea: "",
        platform: "",
        fundsSource: "",
        content1: "",
        content2: "",
        content3: "",
        content4: "",
        content5: "",
        content6: "",
        unitType: "",
        newToTarget: "",
        baseType: "" /* 申报基地类型 */,
        popularBase: "",
        cityOpinion: "" /* 市级意见 */,
        municipalOpinion: 0 /* 市级意见 */,
        provincialOpinion: 0 /* 省级意见 */,
        expertOpinion: "",
        fileName1: "",
        fileUrl1: "",
        fileName2: "",
        fileUrl2: "",
        fileName3: "",
        fileUrl3: "",
        fileName4: "",
        fileUrl4: "",
        fileName5: "",
        fileUrl5: "",
        expertDtoList: [
          {
            expertName: "",
            expertJob: "",
            expertMajor: "",
            expertAchievement: "",
            expertPhone: "",
          },
        ],
      },

      cityBaseList: [
        {
          name: "请选择",
          value: "",
        },
        {
          name: "是",
          value: "是",
        },
        {
          name: "否",
          value: "否",
        },
      ],
      unitList: [
        {
          name: "请选择",
          value: "",
        },
        {
          name: "文化事业场馆（包括图书馆、博物馆、纪念馆等）",
          value: "文化事业场馆（包括图书馆、博物馆、纪念馆等）",
        },
        {
          name: "历史、文化景区、爱国主义教育基地",
          value: "历史、文化景区、爱国主义教育基地",
        },
        {
          name: "教育场所（包括各级各类学校，培训基地等）",
          value: "教育场所（包括各级各类学校，培训基地等）",
        },
        {
          name: "新闻、出版发行单位",
          value: "新闻、出版发行单位",
        },
        {
          name: "社会科学研究机构",
          value: "社会科学研究机构",
        },
        {
          name: "企事业单位",
          value: "企事业单位",
        },
        {
          name: "其他有条件向公众开展社会科学普及的单位和机构",
          value: "其他有条件向公众开展社会科学普及的单位和机构",
        },
      ],
      siteAreaList: [
        {
          name: "请选择",
          value: "",
        },
        {
          name: "50-150平方米",
          value: "50-150平方米",
        },
        {
          name: "150-350平方米",
          value: "150-350平方米",
        },
        {
          name: "350平方米以上",
          value: "350平方米以上",
        },
      ],
      baseList: [
        {
          name: "请选择",
          value: "",
        },
        {
          name: "教育研发类社科普及基地",
          value: "教育研发类社科普及基地",
        },
        {
          name: "文化场馆类社科普及基地",
          value: "文化场馆类社科普及基地",
        },
        {
          name: "媒体传播类社科普及基地",
          value: "媒体传播类社科普及基地",
        },
      ],
    };
  },
  methods: {
    saveExpertOpinion() {
      if (this.dataInfo.expertOpinion == "") {
        this.$message.warn("请进行评审");
        return;
      }
      let declareInfoObj = JSON.parse(sessionStorage.getItem("declareInfo"));
      let params = {
        id: declareInfoObj.checkRecordId,
        expertOpinion: this.dataInfo.expertOpinion,
      };
      decUserAccessUpdateApi(params).then((res) => {
        if (res.status) {
          this.$message.success(res.message);
          setTimeout(() => {
            this.$emit("backProject");
          }, 1000);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    preview(i) {
      if (i == 1) {
        if (this.dataInfo.fileUrl1.indexOf("https") < 0) {
          this.dataInfo.fileUrl1 = this.dataInfo.fileUrl1.replace(
            "http",
            "https"
          );
        }

        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl1}`;
        window.open(url);
      }
      if (i == 2) {
        if (this.dataInfo.fileUrl2.indexOf("https") < 0) {
          this.dataInfo.fileUrl2 = this.dataInfo.fileUrl2.replace(
            "http",
            "https"
          );
        }
        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl2}`;
        window.open(url);
      }
      if (i == 3) {
        if (this.dataInfo.fileUrl3.indexOf("https") < 0) {
          this.dataInfo.fileUrl3 = this.dataInfo.fileUrl3.replace(
            "http",
            "https"
          );
        }
        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl3}`;
        window.open(url);
      }
      if (i == 4) {
        if (this.dataInfo.fileUrl4.indexOf("https") < 0) {
          this.dataInfo.fileUrl4 = this.dataInfo.fileUrl4.replace(
            "http",
            "https"
          );
        }
        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl4}`;
        window.open(url);
      }
      if (i == 5) {
        if (this.dataInfo.fileUrl5.indexOf("https") < 0) {
          this.dataInfo.fileUrl5 = this.dataInfo.fileUrl5.replace(
            "http",
            "https"
          );
        }
        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl5}`;
        window.open(url);
      }
    },

    removeFile(i) {
      if (i == 1) {
        this.dataInfo.fileUrl1 = "";
        this.dataInfo.fileName1 = "";
      }
      if (i == 2) {
        this.dataInfo.fileUrl2 = "";
        this.dataInfo.fileName2 = "";
      }
      if (i == 3) {
        this.dataInfo.fileUrl3 = "";
        this.dataInfo.fileName3 = "";
      }
      if (i == 4) {
        this.dataInfo.fileUrl4 = "";
        this.dataInfo.fileName4 = "";
      }
      if (i == 5) {
        this.dataInfo.fileUrl5 = "";
        this.dataInfo.fileName5 = "";
      }
    },
    uploadSelect(file, i) {
      const isPDF = file.type === 'application/pdf';
      var form = new FormData();
      form.append("multipartFile", file);
      if (!isPDF) {
        this.$message.error(`${file.name} 不是一个PDF文件，请重新上传！`);
        this.spinning = false;
        this.spinning2 = false;
        this.spinning3 = false;
        this.spinning4 = false;
        this.spinning5 = false;
        return
      } else {
        openUploadApi(form).then((res) => {
          console.log(res);
          if (i == 1) {
            this.dataInfo.fileUrl1 = res.data;
            this.dataInfo.fileName1 = file.name;
            this.spinning = false;
          };
          if (i == 2) {
            this.dataInfo.fileUrl2 = res.data;
            this.dataInfo.fileName2 = file.name;
            this.spinning2 = false;
          };
          if (i == 3) {
            this.dataInfo.fileUrl3 = res.data;
            this.dataInfo.fileName3 = file.name;
            this.spinning3 = false;
          };
          if (i == 4) {
            this.dataInfo.fileUrl4 = res.data;
            this.dataInfo.fileName4 = file.name;
            this.spinning4 = false;
          }
          if (i == 5) {
            this.dataInfo.fileUrl5 = res.data;
            this.dataInfo.fileName5 = file.name;
            this.spinning5 = false;
          }
        });
      }
    },
    uploaderCoverUrlOne(option) {
      this.spinning = true;
      this.uploadSelect(option.file, 1);

    },
    uploaderCoverUrlOne2(option) {
      this.spinning2 = true;
      this.uploadSelect(option.file, 2);
    },
    uploaderCoverUrlOne3(option) {
      this.spinning3 = true;
      this.uploadSelect(option.file, 3);

    },
    uploaderCoverUrlOne4(option) {
      this.spinning4 = true;
      this.uploadSelect(option.file, 4);
    },
    uploaderCoverUrlOne5(option) {
      this.spinning5 = true;
      this.uploadSelect(option.file, 5);
    },
    createdecInformation(i) {
      let obj = JSON.parse(localStorage.getItem("userModel"));
      let params = {
        extraInfo: JSON.stringify(this.dataInfo),
        type: 1,
        fromSource: obj.userType,
        status: i,
        toTarget: "cityAdm",
        projectYear: "2023",
        unitName: this.dataInfo.unitName,
        baseName: this.dataInfo.baseName,
        projectName: this.dataInfo.baseName,
        decEntrance: this.dataInfo.entrance,
        secondaryDecEntrance: obj.secondaryDecEntrance,
        linkMan: this.dataInfo.contact,
        linkPhone: this.dataInfo.contactPhone,
        cityOpinion: "", //之前的市审核员审核意见要清空
        provinceOpinion: "", //之前的省审核员审核意见要清空
      };
      if (this.userTypeValue == "declarator") {
        params.toTarget = "cityAdm";
      } else if (this.userTypeValue == "cityAdm") {
        params.toTarget = "provinceAdm";
      }
      if (this.toTarget == "cityAdm") {
        if (this.dataInfo.cityOpinion == "") {
          this.$message.warn("市级意见不能为空");
          return;
        }
        params.cityOpinion = this.dataInfo.cityOpinion;
      }
      if (
        this.dataInfo.entrance == "省属机关" ||
        this.dataInfo.entrance == "省属学会" ||
        this.dataInfo.entrance == "省属企业"
      ) {
        params.toTarget = "provinceAdm";
      }
      // 保存草稿
      // if (i == 0) {
      //   params.toTarget = "declarator";
      // }
      if (sessionStorage.getItem("declareInfo")) {
        let declareInfoObj = JSON.parse(sessionStorage.getItem("declareInfo"));
        params.id = declareInfoObj.id;
        if (this.userTypeValue == "cityAdm") {
          params.cityCheckUid = obj.productUserId;
        } else {
          params.cityCheckUid = 0;
        }
        params.cityEvaluation = ""; //修改清除市评分
        params.secondaryDecEntrance = declareInfoObj.secondaryDecEntrance
        if (params.decEntrance !== '部属、省属高校') {
          params.secondaryDecEntrance = ""
        }
        updateDecInformationApi(params).then((res) => {
          if (res.status) {
            this.$message.success(res.message);
            setTimeout(() => {
              this.$emit("backProject");
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        params.createUid = obj.productUserId;
        if (params.decEntrance !== '部属、省属高校') {
          params.secondaryDecEntrance = ""
        }
        createdecInformationApi(params).then((res) => {
          if (res.status) {
            this.$message.success(res.message);
            setTimeout(() => {
              this.$emit("backProject");
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
      // createdecInformationApi(params).then((res) => {
      //   if (res.status) {
      //     this.$message.success(res.message);
      //     setTimeout(() => {
      //       this.$emit("backProject");
      //     }, 1000);
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
    },
    save(i) {
      if (i == 1) {
        if (this.dataInfo.unitName == "") {
          this.$message.warn("请填写申报单位名称");
          return;
        }
        if (this.dataInfo.representative == "") {
          this.$message.warn("请填写法定代表人");
          return;
        }
        if (this.dataInfo.baseName == "") {
          this.$message.warn("请填写拟申报基地名称");
          return;
        }
        if (this.dataInfo.entrance == "") {
          this.$message.warn("请填写申报入口");
          return;
        }
        if (this.dataInfo.unitType == "") {
          this.$message.warn("请选择申报单位类别");
          return;
        }
        if (this.dataInfo.baseType == "") {
          this.$message.warn("请选择申报基地类型");
          return;
        }
        if (this.dataInfo.popularBase == "") {
          this.$message.warn("请选择市级社科普及基地");
          return;
        }
        if (this.dataInfo.supervisorUnit == "") {
          this.$message.warn("请填写上级主管单位");
          return;
        }
        if (this.dataInfo.responsor == "") {
          this.$message.warn("请填写基地负责人");
          return;
        }
        if (this.dataInfo.responsorPosition == "") {
          this.$message.warn("请填写职务职称");
          return;
        }
        if (this.dataInfo.responsorPhone == "") {
          this.$message.warn("请填写手机");
          return;
        }
        if (this.dataInfo.contact == "") {
          this.$message.warn("请填写基地联络员");
          return;
        }
        if (this.dataInfo.contactPosition == "") {
          this.$message.warn("请填写职务职称");
          return;
        }
        if (this.dataInfo.contactPhone == "") {
          this.$message.warn("请填写手机");
          return;
        }
        if (this.dataInfo.mailingAddress == "") {
          this.$message.warn("请填写通讯地址");
          return;
        }
        if (this.dataInfo.postcode == "") {
          this.$message.warn("填写请邮政编码");
          return;
        }
        if (this.dataInfo.phone == "") {
          this.$message.warn("请填写电话（传真）");
          return;
        }
        if (this.dataInfo.platform == "") {
          this.$message.warn("请填写官方网络平台");
          return;
        }
        if (this.dataInfo.email == "") {
          this.$message.warn("请填写电子邮箱");
          return;
        }
        if (this.dataInfo.financialAccount == "") {
          this.$message.warn("请填写财务账号名称");
          return;
        }
        if (this.dataInfo.bankAccount == "") {
          this.$message.warn("请填写开户行及账号");
          return;
        }
        if (this.dataInfo.siteArea == "") {
          this.$message.warn("请选择社科普及场所面积");
          return;
        }
        if (this.dataInfo.fundsSource == "") {
          this.$message.warn("请填写科普经费及来源");
          return;
        }
        if (this.dataInfo.content1 == "") {
          this.$message.warn("请填写场馆设施或普及平台情况");
          return;
        }
        if (this.dataInfo.content2 == "") {
          this.$message.warn("请填写特色普及资源或品牌项目");
          return;
        }

        if (this.dataInfo.content4 == "") {
          this.$message.warn("请填写志愿者队伍情况");
          return;
        }
        if (this.dataInfo.content5 == "") {
          this.$message.warn("请填写近两年社科普及相关工作和社会成效");
          return;
        }
        if (this.dataInfo.content6 == "") {
          this.$message.warn("请填写社科普及基地建设的基本思路与规划方案");
          return;
        }
        if (this.dataInfo.content3 == "") {
          this.$message.warn("请填写社科普及工作人员及专家骨干");
          return;
        }

        if (this.dataInfo.fileName1 == "") {
          this.$message.warn("请上传社科普及资源情况材料");
          return;
        }
        if (this.dataInfo.fileName2 == "") {
          this.$message.warn("请上传社科普及工作人员及专家骨干材料");
          return;
        }
        if (this.dataInfo.fileName3 == "") {
          this.$message.warn("请上传志愿者队伍情况材料");
          return;
        }
        if (this.dataInfo.fileName4 == "") {
          this.$message.warn("请上传近两年社科普及相关工作和社会成效材料");
          return;
        }
        if (this.dataInfo.fileName5 == "") {
          this.$message.warn("请上传社科普及基地建设的基本思路和规划方案材料");
          return;
        }
      }

      this.createdecInformation(i);
    },
    handleChange() { },
    addExpert() {
      this.dataInfo.expertDtoList.push({
        expertName: "",
        expertJob: "",
        expertMajor: "",
        expertAchievement: "",
        expertPhone: "",
      });
    },
    cancel() {
      this.$emit("backProject");
    },
  },
  created() {
    this.routerKey = this.$route.path;
    if (localStorage.getItem("userModel")) {
      let obj = JSON.parse(localStorage.getItem("userModel"));
      this.dataInfo.unitName = obj.unitName;
      this.dataInfo.entrance = obj.decEntrance;
      this.userTypeValue = JSON.parse(
        localStorage.getItem("userModel")
      ).userType;
    }
    // 数据清空
    if (!sessionStorage.getItem("declareInfo")) {
      this.saveStatus = 0;
      this.declareStatus = 0;
      this.dataInfo.representative = "";
      this.dataInfo.baseName = "";
      this.dataInfo.supervisorUnit = "";
      this.dataInfo.responsor = "";
      this.dataInfo.responsorPosition = "";
      this.dataInfo.responsorPhone = "";
      this.dataInfo.contact = "";
      this.dataInfo.contactPosition = "";
      this.dataInfo.contactPhone = "";
      this.dataInfo.mailingAddress = "";
      this.dataInfo.postcode = "";
      this.dataInfo.phone = "";
      this.dataInfo.email = "";
      this.dataInfo.financialAccount = "";
      this.dataInfo.bankAccount = "";
      this.dataInfo.siteArea = "";
      this.dataInfo.platform = "";
      this.dataInfo.fundsSource = "";
      this.dataInfo.content1 = "";
      this.dataInfo.content2 = "";
      this.dataInfo.content3 = "";
      this.dataInfo.content4 = "";
      this.dataInfo.content5 = "";
      this.dataInfo.content6 = "";
      this.dataInfo.unitType = "";
      this.dataInfo.baseType = "";
      this.dataInfo.popularBase = "";
      this.dataInfo.cityOpinion = "";
      this.dataInfo.expertOpinion = "";
      this.dataInfo.fileName1 = "";
      this.dataInfo.fileName2 = "";
      this.dataInfo.fileName3 = "";
      this.dataInfo.fileName4 = "";
      this.dataInfo.fileName5 = "";
      this.dataInfo.fileUrl1 = "";
      this.dataInfo.fileUrl2 = "";
      this.dataInfo.fileUrl3 = "";
      this.dataInfo.fileUrl4 = "";
      this.dataInfo.fileUrl5 = "";
      this.dataInfo.municipalOpinion = 0;
      this.dataInfo.provincialOpinion = 0;
      this.newToTarget = "";
      this.dataInfo.expertDtoList = [
        {
          expertName: "",
          expertJob: "",
          expertMajor: "",
          expertAchievement: "",
          expertPhone: "",
        },
      ];
    } else {
      // 回显
      let declareInfoObj = JSON.parse(sessionStorage.getItem("declareInfo"));
      this.newToTarget = declareInfoObj.toTarget;
      this.dataInfo.representative = JSON.parse(
        declareInfoObj.extraInfo
      ).representative;
      this.dataInfo.baseName = JSON.parse(declareInfoObj.extraInfo).baseName;
      this.dataInfo.supervisorUnit = JSON.parse(
        declareInfoObj.extraInfo
      ).supervisorUnit;
      this.dataInfo.responsor = JSON.parse(declareInfoObj.extraInfo).responsor;
      this.dataInfo.responsorPosition = JSON.parse(
        declareInfoObj.extraInfo
      ).responsorPosition;
      this.dataInfo.responsorPhone = JSON.parse(
        declareInfoObj.extraInfo
      ).responsorPhone;
      this.dataInfo.contact = JSON.parse(declareInfoObj.extraInfo).contact;
      this.dataInfo.contactPosition = JSON.parse(
        declareInfoObj.extraInfo
      ).contactPosition;
      this.dataInfo.contactPhone = JSON.parse(
        declareInfoObj.extraInfo
      ).contactPhone;
      this.dataInfo.mailingAddress = JSON.parse(
        declareInfoObj.extraInfo
      ).mailingAddress;
      this.dataInfo.postcode = JSON.parse(declareInfoObj.extraInfo).postcode;
      this.dataInfo.phone = JSON.parse(declareInfoObj.extraInfo).phone;
      this.dataInfo.email = JSON.parse(declareInfoObj.extraInfo).email;
      this.dataInfo.financialAccount = JSON.parse(
        declareInfoObj.extraInfo
      ).financialAccount;
      this.dataInfo.bankAccount = JSON.parse(
        declareInfoObj.extraInfo
      ).bankAccount;
      this.dataInfo.cityOpinion = JSON.parse(
        declareInfoObj.extraInfo
      ).cityOpinion;
      this.dataInfo.expertOpinion = declareInfoObj.expertOpinion;

      this.dataInfo.siteArea = JSON.parse(declareInfoObj.extraInfo).siteArea;
      this.dataInfo.platform = JSON.parse(declareInfoObj.extraInfo).platform;
      this.dataInfo.fundsSource = JSON.parse(
        declareInfoObj.extraInfo
      ).fundsSource;
      this.dataInfo.content1 = JSON.parse(declareInfoObj.extraInfo).content1;
      this.dataInfo.content2 = JSON.parse(declareInfoObj.extraInfo).content2;
      this.dataInfo.content3 = JSON.parse(declareInfoObj.extraInfo).content3;
      this.dataInfo.content4 = JSON.parse(declareInfoObj.extraInfo).content4;
      this.dataInfo.content5 = JSON.parse(declareInfoObj.extraInfo).content5;
      this.dataInfo.content6 = JSON.parse(declareInfoObj.extraInfo).content6;
      this.dataInfo.unitType = JSON.parse(declareInfoObj.extraInfo).unitType;
      this.dataInfo.baseType = JSON.parse(declareInfoObj.extraInfo).baseType;
      this.dataInfo.fileName1 = JSON.parse(declareInfoObj.extraInfo).fileName1;
      this.dataInfo.fileName2 = JSON.parse(declareInfoObj.extraInfo).fileName2;
      this.dataInfo.fileName3 = JSON.parse(declareInfoObj.extraInfo).fileName3;
      this.dataInfo.fileName4 = JSON.parse(declareInfoObj.extraInfo).fileName4;
      this.dataInfo.fileName5 = JSON.parse(declareInfoObj.extraInfo).fileName5;
      this.dataInfo.fileUrl1 = JSON.parse(declareInfoObj.extraInfo).fileUrl1;
      this.dataInfo.fileUrl2 = JSON.parse(declareInfoObj.extraInfo).fileUrl2;
      this.dataInfo.fileUrl3 = JSON.parse(declareInfoObj.extraInfo).fileUrl3;
      this.dataInfo.fileUrl4 = JSON.parse(declareInfoObj.extraInfo).fileUrl4;
      this.dataInfo.fileUrl5 = JSON.parse(declareInfoObj.extraInfo).fileUrl5;
      this.dataInfo.popularBase = JSON.parse(
        declareInfoObj.extraInfo
      ).popularBase;
      this.dataInfo.municipalOpinion = JSON.parse(
        declareInfoObj.extraInfo
      ).municipalOpinion;
      this.dataInfo.provincialOpinion = JSON.parse(
        declareInfoObj.extraInfo
      ).provincialOpinion;
      this.dataInfo.expertDtoList = JSON.parse(
        declareInfoObj.extraInfo
      ).expertDtoList;
      this.declareStatus = declareInfoObj.status;
      this.saveStatus = 1;
      this.dataInfo.unitName = JSON.parse(declareInfoObj.extraInfo).unitName;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
